module.exports = __webpack_public_path__ + "20bf2d5b4788dae5298d6e5137f1dd20.svg";